module.exports = __webpack_public_path__ + "static/media/logo.9e5490f5.png";